import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_STATUS } from './url-constants';

type AlarmStatusEndpointSpecification = ApiEndpointSpecification;
export const AlarmStatusEndpointSpecification: AlarmStatusEndpointSpecification = {
    url: ALARM_STATUS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'AlarmStatusRequestParams',
    requestBodySchemaName: 'AlarmStatusRequestBody',
    okResponseSchemaName: 'AlarmStatusOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmStatus = Helpers.makeApiRequestFn<
    Types.AlarmStatusRequestParams,
    Types.AlarmStatusRequestBody,
    Types.AlarmStatusOkResponse
>(AlarmStatusEndpointSpecification);
